import React, { useState } from 'react';
import '../Assets/CSS/Navbar.scss';
import logo from '../Assets/Images/logo.png';
import { FaBars, FaTimes } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  
  const toggleMenu = () => setIsOpen(!isOpen);
  
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  // Function to close mobile menu when any link is clicked
  const closeMobileMenu = () => {
    setIsOpen(false);
    setOpenDropdown(null);
  };

  return (
    <>
      <nav className="navbar font-heading">
        {/* Always show logo, but adjust spacing when menu is open */}
        <NavLink to="/" className={isOpen ? 'logo-hidden' : ''}>
          <img src={logo} alt="Logo" className="logo" />
        </NavLink>

        <div className="nav-links-container">
          <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
            <li><NavLink to="/" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMobileMenu}>Home</NavLink></li>
            <li><NavLink to="/about-us" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMobileMenu}>About Us</NavLink></li>

            <li className="dropdown">
              <span className={`dropdown-label ${isOpen ? 'open' : ''}`}>
                <span><NavLink to="/product" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMobileMenu}>Products</NavLink></span>
              </span>
            </li>

            <li className="dropdown">
              <span className={`dropdown-label ${isOpen ? 'open' : ''}`}>
                <span><NavLink to="/service" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMobileMenu}>Services</NavLink></span>
              </span>
            </li>

            <li className="dropdown">
              <span 
                className={`dropdown-label ${isOpen ? 'open' : ''}`}
                onClick={() => toggleDropdown('insights')}
              >
                <span>Insights</span>
                {openDropdown === 'insights' ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
              </span>
              <ul className={`dropdown-menu ${openDropdown === 'insights' ? 'open' : ''}`}>
                <li><NavLink to="/blog" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMobileMenu}>Blog</NavLink></li>
                <li><NavLink to="/casestudies" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMobileMenu}>Case Studies</NavLink></li>
                <li><NavLink to="/news" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMobileMenu}>News</NavLink></li>
              </ul>
            </li>

            <li><NavLink to="/contact" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMobileMenu}>Contact</NavLink></li>
            <li><NavLink to="/careers" className={({ isActive }) => isActive ? "active-link" : ""} onClick={closeMobileMenu}>Careers</NavLink></li>
            
            <NavLink to="/freedemo">
              {isOpen && (
                <li>
                  <button className="demo-button mobile-inline" onClick={closeMobileMenu}>Book Free Demo</button>
                </li>
              )}
            </NavLink>
          </ul>
        </div>

        <NavLink to="/freedemo">
          {!isOpen && (
            <button className="demo-button desktop">Book Free Demo</button>
          )}
        </NavLink>

        <div className="hamburger" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>
      </nav>
    </>
  );
};

export default Navbar;